import React from 'react'
import { Controller, useFormState } from 'react-hook-form'
import { Radio } from 'antd'
import styles from './RadioField.module.css'

// Composant pour le cas isActiveSubmit = true
const ActiveRadioField = ({ field, control, setValue }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]

  const defaultValue =
    Array.isArray(field.VALUE__reponse) && field.VALUE__reponse.length > 0
      ? field.VALUE__reponse[0]
      : ''

  const input_style = field.input_design ? { ...field.input_design } : {}
  const RadioRender = ({ onChange = () => {}, value }) => {
    let inputClass = ''

    if (isSubmitted) {
      inputClass = error ? 'input-error' : 'input-success'
    }

    return (
      <Radio.Group
        className={`radio_button_group ${styles.radio_button_group_column} ${inputClass}`}
        style={input_style || {}}
        onChange={(e) => onChange(e.target.value)}
        value={value}
      >
        {field.options.map((option, index) => (
          <Radio key={index} value={option.value}>
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
    )
  }

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      rules={{ required: field.required }}
      render={({ field: { onChange, value } }) => (
        <RadioRender onChange={onChange} value={value} />
      )}
      // defaultValue={field.VALUE__reponse || field.options[0]?.value || ''}
      defaultValue={defaultValue}
    />
  )
}

// Composant pour le cas isActiveSubmit = false
const InactiveRadioField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}
  return (
    <Radio.Group
      className={`radio_button_group ${styles.radio_button_group_column}`}
      style={input_style || {}}
    >
      {field.options.map((option, index) => (
        <Radio key={index} value={option.value}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  )
}

const RadioField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveRadioField field={field} control={control} />
  ) : (
    <InactiveRadioField field={field} />
  )
}

export default RadioField
